import React, { useState, useEffect, useRef, MouseEvent } from "react";
import "../../Styles/TitleBarStyle.scss";
// import "./TitleBar.css";

import SalutationTitle from "./SalutationTitle";
// import HamburgerIcon from "../TitleBar/HamburgerIcon";
import TitleToolBar from "./TitleToolBar";
import HamburgerToolBarItems from "./HamburgerToolBarItems";
import ScreenTitle from "./ScreenTitle";
import DSBAlogo from "../../Images/DSBAlogo.png";
import polygon from "../../Images/Polygon.png";
import profilepic from "../../Images/profilepic.png";
import HamburgerIcon from "../../Images/MenuIconComp/HamburgerIcon";
// import ProfileDropdownMenu from "./ProfileDropdownMenu";
// import SmallScreenSideMenu from "./SmallScreenSideMenu";
import { Link, useNavigate } from "react-router-dom";
import ReactModal from "react-modal";
import FindMemberIcon from "../../Images/MemberIconComp/FindMemberIcon";
import NewMemberIcon from "../../Images/MemberIconComp/NewMemberIcon";
import SettingIcon from "../../Images/MenuIconComp/SettingIcon";

const TitleBar: React.FC = () => {
  const [isProfileDropdownMenuOpen, setisProfileDropdownMenuOpen] =
    useState(false);
  const [isSmallScreenSideMenuOpen, setIsSmallScreenSideMenuOpen] =
    useState(true);
  const [isAnyDropdownMenuOpen, setIsAnyDropdownMenuOpen] = useState(true);

  const navigate = useNavigate();

  const [profileMenuModalOpen, setProfileMenuModalOpen] = useState(false);
  const [smallScreenSideMenuModalOpen, setSmallScreenSideMenuModalOpen] =
    useState(false);

  const firstName = sessionStorage.getItem("FirstName");
  const lastName = sessionStorage.getItem("LastName");

  let handleProfileDropdownMenuClick = () => {
    // setisProfileDropdownMenuOpen(!isProfileDropdownMenuOpen);
    // setIsAnyDropdownMenuOpen(!isAnyDropdownMenuOpen);
    setProfileMenuModalOpen(!profileMenuModalOpen);
  };

  let logout = () => {
    console.log("logout called");
    sessionStorage.clear();
    navigate("/sign-in", { replace: false });
  };

  let handleSmallScreenSideMenuClick = () => {
    // setIsSmallScreenSideMenuOpen(!isSmallScreenSideMenuOpen);
    // setIsAnyDropdownMenuOpen(!isAnyDropdownMenuOpen);
    setSmallScreenSideMenuModalOpen(!smallScreenSideMenuModalOpen);
  };

  // let CloseDownMenuOpen = () => {
  //   setisProfileDropdownMenuOpen(false);
  //   setIsAnyDropdownMenuOpen(false);
  //   setIsSmallScreenSideMenuOpen(false);
  // };

  let logoutMenuRef = useRef<any>(null);
  let smallScreenMenuRef = useRef<any>(null);

  // React.useEffect(() => {
  //   console.log("test");

  // function useOnClickOutside(ref: React.RefObject<any>, handler: () => void) {
  //   React.useEffect(() => {
  //     const listener = (event: TouchEvent | MouseEvent) => {
  //       if (!ref || !ref.current) {
  //         return;
  //       }

  //     const handleContextMenu = (rowParam: number, cellParam: number) => (e: React.MouseEvent<HTMLDivElement, MouseEvent>) : void => {
  //       e.preventDefault();
  // }

  //   const handler =
  //     () =>
  //     (e: React.MouseEvent<Element, MouseEvent>): void => {
  //       e.preventDefault();
  //       if (!logoutMenuRef || !logoutMenuRef.current) {
  //         console.log("logoutMenuRef");
  //         return;
  //       }
  //       if (!logoutMenuRef.current?.contains(e.target as Node)) {
  //         setisProfileDropdownMenuOpen(false);
  //         console.log("result");
  //       }
  //     };

  //   document.addEventListener("mousedown", handler);

  //   return () => {
  //     document.removeEventListener("mousedown", handler);
  //   };
  // }, []);

  return (
    <div className="titlebar-component justify-content-around justify-content-lg-between">
      <div className="d-none d-lg-block">
        <img className="logo-img " src={DSBAlogo} alt="DSBA" />
      </div>
      <div
        className="d-flex d-lg-none col-lg-3 "
        onClick={handleSmallScreenSideMenuClick}
      >
        <HamburgerIcon height={30} width={30} />
      </div>
      {/* <div
        className={`d-flex d-lg-none small-screen-sidemenu ${
          isSmallScreenSideMenuOpen ? "active" : "inactive"
        }`}
        ref={smallScreenMenuRef}
      > */}
      {/* <SmallScreenSideMenu
          onChangeFunction={handleSmallScreenSideMenuClick}
        /> */}
      {/* </div> */}
      <ReactModal
        isOpen={smallScreenSideMenuModalOpen}
        onRequestClose={() => setSmallScreenSideMenuModalOpen(false)}
        className="d-flex d-lg-none small-screen-sidemenu"
        overlayClassName="overlay"
      >
        <ul>
          <li onClick={handleSmallScreenSideMenuClick}>
            <Link to="member">
              <span className="icon">
                <FindMemberIcon />
              </span>
              <span>Find Member</span>
            </Link>
          </li>
          <li onClick={handleSmallScreenSideMenuClick}>
            <Link to="create-member">
              <span className="icon">
                <NewMemberIcon />
              </span>
              <span>New Member</span>
            </Link>
          </li>
          <li onClick={handleSmallScreenSideMenuClick}>
            <Link to="settings">
              <span className="icon">
                <SettingIcon />
              </span>
              <span>Settings</span>
            </Link>
          </li>
        </ul>
      </ReactModal>
      <div className="dsba-name col-9 col-lg-6">
        Delaware State Bar Association
      </div>
      <div
        className="user-profile-wrapper d-none d-lg-flex"
        onClick={handleProfileDropdownMenuClick}
      >
        <img className="profile-img" src={profilepic} alt="DSBA" />
        <div className="username">
          {firstName} {lastName}
        </div>
        <img className="polygon-img" src={polygon} alt="DSBA" />
        {/* <div
          className={`profile-dropdown ${
            isProfileDropdownMenuOpen ? "active" : "inactive"
          }`}
          ref={logoutMenuRef}
        >
          // <ProfileDropdownMenu onChangeFunction={logout} /> 
        </div> */}
      </div>
      <ReactModal
        isOpen={profileMenuModalOpen}
        onRequestClose={() => setProfileMenuModalOpen(false)}
        className="profile-dropdown"
        overlayClassName="overlay"
      >
        <ul>
          <li onClick={logout}>
            <Link to="member">
              <span className="icon">
                <FindMemberIcon />
              </span>
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </ReactModal>
      {/* <div
        className={`overlay-fullscreen ${
          isProfileDropdownMenuOpen ? "active" : "inactive"
        } d-none d-lg-block`}
        onClick={() => CloseDownMenuOpen()}
      ></div>
      <div
        className={`overlay-fullscreen ${
          isSmallScreenSideMenuOpen ? "active" : "inactive"
        } d-block d-lg-none`}
        onClick={() => CloseDownMenuOpen()}
      ></div> */}
    </div>
  );
};

export default TitleBar;
